import React, { Component, Fragment } from 'react';
import { Redirect } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import styled from 'styled-components';
import H2 from '../../collections/H2/H2';
import ButtonWrapper from '../../components/Form/ButtonWrapper';
import Button from '../../collections/Button/Button';
import { media } from '../../utilities/style-utilities';
import { isMobile } from 'react-device-detect';

// const queryString = require('query-string');

const TextBox = styled.div`
  padding: 20px;
`;

const PreviewWrapper = styled.div`
  display: flex;
  width: 100%;
  margin: auto;
  max-width: 964px;
  background-color: white;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 300px;
  z-index: 1;
  margin-top: 0;
  margin-bottom: 0;
  border-radius: 0;
  -webkit-box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.3);
  -moz-box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.3);
  box-shadow: 0px 0px 6px 2px rgba(0, 0, 0, 0.3);
  font-family: 'Edenred !important';
`;

const PreviewImage = styled.div`
  background-size: contain;
  background-position: center;
  width: 50%;
  height: 100%;
  width: 100%;
  margin: 15px auto;
  max-height: 300px;
  background-repeat: no-repeat;
  ${media.desktop`
         background-position: top;
         background-size:cover;  
    `}
`;

const buttonStyle = {
  width: 'auto',
  padding: '.6rem 3rem;',
  fontFamily: 'Edenred',
};

class DealsPreview extends Component {
  render() {
    // let parsed = queryString.parse(this.props.location.search);
    const previewBackground = {
      backgroundImage: `url("${this.props.appState.ui.dealsPreview.imageSrc}")`,
      height: '250px',
      backgroundSize: 'contain',
    };

    const headerStyles = {
      textAlign: 'center',
      fontSize: '30px',
      lineHeight: 'unset',
      fontFamily: 'Edenred',
    };

    // const captionStyles = {
    //   textAlign: 'center',
    // };
    // if(parsed.source === 'mobile') {
    if (isMobile) {
      return (
        <Fragment style={{ margin: 'auto' }}>
          <Helmet>
            {/* props.appState.ui.terms.meta.title */}
            <title>{`Incentive Award Card`}</title>
            <meta
              name='description'
              content={`props.appState.ui.terms.meta.description`}
            />
          </Helmet>
          {/* props.appState.ui.terms.card.titleText */}
          <PreviewWrapper>
            <PreviewImage style={previewBackground}></PreviewImage>
            <TextBox>
              <H2 style={headerStyles}>Our amazing deals</H2>
            </TextBox>
            <ButtonWrapper style={{ margin: '15px auto' }}>
              <Link to={`${window.location.origin}/deals`} target='_blank'>
                <Button
                  style={buttonStyle}
                  color='#fff'
                  background='#0085ca'
                  border='#0085ca'
                  type='submit'
                  role='button'
                >
                  Start shopping
                </Button>
              </Link>
            </ButtonWrapper>
          </PreviewWrapper>
        </Fragment>
      );
    } else {
      return <Redirect to='/not-found' />;
    }
  }
}

export default DealsPreview;



// WEBPACK FOOTER //
// ./src/containers/DealsPreview/DealsPreview.js